<template src="./template.html"></template>
<script>
import { mapGetters } from 'vuex';
import CostTable from '../../modules/01_costtable';
import PageHeading from '../../modules/03_page_heading';

import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons/print'
import 'vue-awesome/icons/regular/file'

export default {
  components: { CostTable, PageHeading, Icon },
  computed: {
    ...mapGetters(['get_supplier', 'get_customer', 'get_pdf', 'get_order_created', 'get_selection', 'get_selected_panels', 'get_wording', 'get_selected_building_slug', 'get_building_info']),
    buildingImage () {
        return this.$resourcesUrl + this.get_building_info.image;
    },
  },
  props: ['step'],
  beforeMount () {
    this.$store.dispatch('UPDATE_STEPS', this.$props.step);
  },
  created () {
    // Check route to redirect
    if( !this.get_order_created ){
      this.$router.push('/');
    }else if( this.get_selection.activeField === 0 ){
      this.$router.push(`/${this.get_selected_building_slug}`);
    }else if( this.get_selected_panels.length === 0 ){
      this.$router.push(`/${this.get_selected_building_slug}/step-2`);
    }
  },
  methods: {
    downloadPDF() {
      window.open(this.$apiUrl + this.get_pdf.download);
    },
    printPDF() {
      window.open(this.$apiUrl + this.get_pdf.link);
    },
    getApprovalMessage() {
        let msg1 = 'Vielen Dank für Ihre Bestellung, ';
        let msgCustomer = '. Sie erhalten in Kürze eine Bestätigung per E-Mail.'
        let msgGift = '. Sie erhalten in Kürze eine Bestätigung per E-Mail.'
        let customer = this.get_customer.salutation.name + ' ';

        if( this.get_customer.salutation.name == undefined || this.get_customer.salutation.name == 'Firma' ) {
          customer = '';
        }
        if (this.get_customer.company !== '') {
            customer += this.get_customer.company;
        } else {
            customer += this.get_customer.firstname +" "+this.get_customer.lastname;
        }

        let hasOwner = false;

        for(var ii=0; ii < this.get_selected_panels.length; ii++){
          if( this.get_selected_panels[ii].owner.has ){
            hasOwner = true;
          }
        }
        

        if( hasOwner ){
          return msg1 + customer + msgGift;
        }else{
          return msg1 + customer + msgCustomer;
        }
        
    }
  },
};

</script>



// WEBPACK FOOTER //
// src/components/pages/05_summary/index.vue